<template>
  <label class="checkbox-label relative cursor-pointer flex">
    <input class="absolute cursor-pointer" :id="id" type="checkbox" :checked="checked" @change="toggleChecked" />
    <div class="check-container flex justify-center" :class="{ 'valid-error': error }">
      <span class="check material-icons font-bold" v-show="checked">check</span>
    </div>
    <slot></slot>
  </label>
</template>

<script>
export default {
    data () {
        return {
            lang:""
        }
    },
    props: {
    id: String,
    formattedLabel: String,
    checked: Boolean,
				error: Boolean

  },
   methods: {
    toggleChecked() {
      this.$emit("update:checked", !this.checked);
    },
  },
  created() {
    this.lang = window.appLocale;
  }
};
</script>
